import { useCallback, useEffect, useRef, useState } from 'react';

import { getTenantUsers } from '../../users/api/users.api';
import type { UserApiUser } from '../../users/types/user.types';

export function useTenantUsers(tenantId: number | undefined) {
  const [users, setUsers] = useState<UserApiUser[]>([]);
  const [loading, setLoading] = useState(Boolean(tenantId));
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);
  const generationRef = useRef(0);

  const loadUsers = useCallback(() => {
    const generation = ++generationRef.current;
    const isCurrent = () => mountedRef.current && generationRef.current === generation;

    if (tenantId === undefined) {
      setUsers([]);
      setLoading(false);
      setError(null);
      return Promise.resolve();
    }

    setLoading(true);
    setError(null);
    return getTenantUsers(tenantId)
      .then((result) => {
        if (isCurrent()) setUsers(result.users);
      })
      .catch(() => {
        if (isCurrent()) setError('خطا در دریافت کاربران این تننت');
      })
      .finally(() => {
        if (isCurrent()) setLoading(false);
      });
  }, [tenantId]);

  useEffect(() => {
    mountedRef.current = true;
    void loadUsers();
    return () => {
      mountedRef.current = false;
    };
  }, [loadUsers]);

  return { users, loading, error, refetch: loadUsers };
}
